import styled from 'styled-components';

export const AdminHeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: white;
  border-bottom: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 768px) {
    padding: 12px 16px;
    padding-left: 80px; /* Space for mobile menu button */
  }

  @media (max-width: 480px) {
    padding: 8px 12px;
    padding-left: 70px;
  }
`;

export const AdminHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const AdminHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const AdminHeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #212529;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const AdminHeaderSubtitle = styled.p`
  font-size: 14px;
  color: #6c757d;
  margin: 0;
  margin-top: 2px;

  @media (max-width: 768px) {
    font-size: 12px;
    display: none; /* Hide subtitle on mobile to save space */
  }
`;

export const AdminHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AdminHeaderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: #f8f9fa;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
  min-width: 44px; /* Touch-friendly minimum width */
  min-height: 44px; /* Touch-friendly minimum height */
  
  &:hover {
    background: #e9ecef;
    color: #495057;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0) scale(0.95);
    background: #dee2e6;
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
`;

export const AdminHeaderUser = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;

  @media (max-width: 768px) {
    display: none; /* Hide user info on mobile to save space */
  }
`;

export const AdminHeaderAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 600;
`;

export const AdminHeaderUserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AdminHeaderUserName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  line-height: 1.2;
`;

export const AdminHeaderUserRole = styled.span`
  font-size: 12px;
  color: #6c757d;
  line-height: 1.2;
`;

// Note: Responsive design handled via CSS media queries in global styles
